import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";

function MyApp ({ router, Component, pageProps }) {
  const path = router.pathname;
  const isRecruit = path.search('/recruit');

  const [ScrollY, setScrollY] = useState(0); // 스크롤값을 저장하기 위한 상태
  const handleFollow = () => {
    setScrollY(window.pageYOffset); // window 스크롤 값을 ScrollY에 저장
  };

  

  useEffect(() => {
    if (ScrollY < 5) {
      document.body.classList.remove('scroll_down', 'scroll_down');
    } else {
      document.body.classList.add('scroll_down');
    }
  }, [ScrollY]);

  useEffect(() => {
    const watch = () => {
      window.addEventListener('scroll', handleFollow);
    };
    watch(); // addEventListener 함수를 실행
    return () => {
      window.removeEventListener('scroll', handleFollow); // addEventListener 함수를 삭제
    };

  }, []);

  useEffect(async () => {
    if (isRecruit === 0) {
      return false;
    }
    
    if(isMobile){//모바일
      if(path !== null){
        let cstPath = path.replace('/m','');
        cstPath = '/m' + cstPath;
        if(path!==cstPath){
          window.location.replace(cstPath);
        }
      }
    }else{//피씨
      let check = path.search('/m');
      if(check === 0){
        if(path==='/m'){
          window.location.replace('/');
        }else{
          let cstPath = path.replace('/m','');
          window.location.replace(cstPath);
        }
      }
    }
  }, []);

  return (
    <>
     {isRecruit !== 0 &&
      <Head>
        <meta name='google-site-verification' content='A8FPDPyVe4prPCljbqy_eRyq3iQazgtIMtjwMHz8Em4' />
        <meta name='naver-site-verification' content='84018caf299c313821354bd9aec9f956228dd998' />
        <link href='/favicon.ico' type='image/x-icon' rel='shortcut icon' />
      </Head>
      }
      <Component {...pageProps} />
    </>
  );
}


export default MyApp;
